import { render, staticRenderFns } from "./jobItemPrice.vue?vue&type=template&id=eed70ef2&scoped=true&"
import script from "./jobItemPrice.vue?vue&type=script&lang=js&"
export * from "./jobItemPrice.vue?vue&type=script&lang=js&"
import style0 from "./jobItemPrice.vue?vue&type=style&index=0&id=eed70ef2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eed70ef2",
  null
  
)

export default component.exports